// The editor's built-in value types: the scalars a flow value can be, plus a
// "List of X" companion for each. Mirrors the backend registry
// `spotflow/spotflow/flow_types.py` — the shared fixture
// `__tests__/flowTypes.json` pins the two together, so change them as a pair.
//
// A single "type" dropdown can't carry a separate is_list flag, so list-ness
// is encoded in the value as `list[<element>]`; `parseFlowInputType` is the
// one place that decoding lives.

export type FlowTypeValue =
  | "str"
  | "number"
  | "bool"
  | "datetime"
  | "File"
  | "object";

export interface FlowType {
  value: FlowTypeValue;
  label: string;
}

export const FLOW_SCALARS: readonly FlowType[] = [
  { value: "str", label: "Text" },
  { value: "number", label: "Number" },
  { value: "bool", label: "Boolean" },
  { value: "datetime", label: "Date Time" },
  { value: "File", label: "File" },
  { value: "object", label: "Object" },
];

const LIST_PREFIX = "list[";
const LIST_LABEL_PREFIX = "List of ";

const BY_VALUE = new Map(FLOW_SCALARS.map((t) => [t.value, t]));
const BY_LABEL = new Map(FLOW_SCALARS.map((t) => [t.label, t]));

export interface FlowInputType {
  dataType: string;
  isList: boolean;
}

export function parseFlowInputType(
  type: string | undefined | null
): FlowInputType {
  const raw = type || "str";
  if (raw.startsWith(LIST_PREFIX) && raw.endsWith("]")) {
    const inner = raw.slice(LIST_PREFIX.length, -1);
    return { dataType: inner || "str", isList: true };
  }
  return { dataType: raw, isList: false };
}

export function formatFlowInputType({
  dataType,
  isList,
}: FlowInputType): string {
  return isList ? `${LIST_PREFIX}${dataType}]` : dataType;
}

/** The registry's label for a built-in data type; undefined otherwise. */
export function flowTypeLabel(dataType: string): string | undefined {
  return BY_VALUE.get(dataType as FlowTypeValue)?.label;
}

/** `"List of Number"` → `{dataType: "number", isList: true}`; undefined for
 * a label the registry doesn't know. */
export function parseFlowTypeLabel(label: string): FlowInputType | undefined {
  const isList = label.startsWith(LIST_LABEL_PREFIX);
  const base = isList ? label.slice(LIST_LABEL_PREFIX.length) : label;
  const scalar = BY_LABEL.get(base);
  return scalar ? { dataType: scalar.value, isList } : undefined;
}
